import React, { useState, useEffect } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import SearchIcon from "../../assets/images/icons/search-icon.webp";
import { BiSearch } from "react-icons/bi";
import { casinoSection } from "../../lib/data/casinoSection.data";
import { auraGames } from "../../lib/data/auraGames.data";
import { aviatorGames } from "../../lib/data/aviatorGames.data";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { QtechGames } from "../../lib/data/QtechGames.data";
import { casinoPageData, EvolutionGames } from "../../lib/data";
import { PragmaticPlayGames } from "../../lib/data/pragmaticplayGames.data";

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);

  const totalGames = [
    ...Object.values(casinoSection?.AndarBahar || {}),
    ...Object.values(casinoSection?.roulettetab || {}),
    ...Object.values(casinoSection?.dragontiger || {}),
    ...Object.values(casinoSection?.blackjacktab || {}),
    ...Object.values(casinoSection?.pokertab || {}),
    ...Object.values(casinoSection?.ezbonuswheel || {}),
    ...Object.values(auraGames?.improvedExperience || {}),
    ...Object.values(auraGames?.cardGames || {}),
    ...Object.values(auraGames?.virtualCardGames || {}),
    ...Object.values(auraGames?.instantGames || {}),
    ...Object.values(SlotGames?.netenttab || {}),
    ...Object.values(SlotGames?.redtigertab || {}),
    ...Object.values(KingmakerGames?.kingmaker || {}),
    ...Object.values(QtechGames?.turbo || {}),
    ...Object.values(QtechGames?.hacksaw || {}),
    ...Object.values(EvolutionGames || {}),
    ...Object.values(QtechGames?.smartSoft || {}),
    ...Object.values(QtechGames?.spribe || {}),
    ...Object.values(aviatorGames || {}),
    ...Object.values(PragmaticPlayGames || {}),
    ...Object.values(casinoPageData.habanero.habanero || {}),
    ...Object.values(casinoPageData.turbo.mines || {}),
    ...Object.values(casinoPageData.hacksaw.hacksaw || {}),
    ...Object.values(casinoPageData.crash.crash || {}),
    ...Object.values(casinoPageData.instantGames.instantGames || {}),
    ...Object.entries(casinoSection?.topGamesnew || {})
       .filter(([key]) => ["EZMarbleRace", "XXXtremeLightningRoulette", "GoldVaultRoulette", "FunkyTime"].includes(key))
       .map(([, value]) => value),
  ];

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };
  const handleSearch = (e) => {
    if (e) {
      let filteredValue = Object.values(totalGames)?.filter((item) => {
        return (
          item?.name && item.name.toLowerCase().indexOf(e?.toLowerCase()) > -1
        );
      });
      setFilteredData(filteredValue);
    } else {
      setFilteredData(null);
    }
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          <img src={SearchIcon} alt="search" />
          {/* <BiSearch /> */}
          <p>Search...</p>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} className="search-modal">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Search Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search your favourite games here..."
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <ul className="gamelisting">
            {filteredData &&
              filteredData.map((item) => (
                <li>
                  <a href={item.redirectUrl}>
                    <img src={item.imgUrl} />
                    <div className="providerName">{item.providerName}</div>
                    <div className="GameName">{item.name}</div>
                  </a>
                </li>
              ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
